// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import ResetOverview from './ResetPasswordOverview';
// Renamed variants
import ResetClassicMinimal from './ResetClassicMinimal';
import ResetHeroImage from './ResetHeroImage';
import ResetDarkMode from './ResetDarkMode';
// Existing variants
import ResetSplit from './ResetSplit';
import ResetGradient from './ResetGradient';
import ResetModern from './ResetModern';
import ResetAnimated from './ResetAnimated';
import ResetIllustrated from './ResetIllustrated';
import ResetParallax from './ResetParallax';
import ResetMinimal3D from './ResetMinimal3D';
import ResetSplitScreen from './ResetSplitScreen';
// New variants
import ResetCenteredCard from './ResetCenteredCard';
import ResetGlassmorphism from './ResetGlassmorphism';
import ResetMobileAppStyle from './ResetMobileAppStyle';
import ResetSocialLogin from './ResetSocialLogin';
import ResetSidebar from './ResetSidebar';
import ResetCarouselOnboarding from './ResetCarouselOnboarding';

export default function ResetRoutes() {
  return (
    <Routes>
      <Route index element={<ResetOverview />} />
      {/* Renamed routes */}
      <Route path="classic-minimal" element={<ResetClassicMinimal />} />
      <Route path="hero-image" element={<ResetHeroImage />} />
      <Route path="dark-mode" element={<ResetDarkMode />} />
      {/* Existing routes */}
      <Route path="split" element={<ResetSplit />} />
      <Route path="gradient" element={<ResetGradient />} />
      <Route path="modern" element={<ResetModern />} />
      <Route path="animated" element={<ResetAnimated />} />
      <Route path="illustrated" element={<ResetIllustrated />} />
      <Route path="parallax" element={<ResetParallax />} />
      <Route path="minimal3d" element={<ResetMinimal3D />} />
      <Route path="splitscreen" element={<ResetSplitScreen />} />
      {/* New routes */}
      <Route path="centered-card" element={<ResetCenteredCard />} />
      <Route path="glassmorphism" element={<ResetGlassmorphism />} />
      <Route path="mobile-app-style" element={<ResetMobileAppStyle />} />
      <Route path="social-login" element={<ResetSocialLogin />} />
      <Route path="sidebar" element={<ResetSidebar />} />
      <Route path="carousel-onboarding" element={<ResetCarouselOnboarding />} />
    </Routes>
  );
}
